module.exports = __webpack_public_path__ + "static/media/扫码成功@2x.f0cd9.png";